import NBType, { InferType } from '@netbase/nb-type'

const AccountProfileInfoSchema = NBType.object().shape('AccountProfileInfoSchema', {
  /* @prop */
  accountName: NBType.string(),
  /* @prop */
  accountProfileId: NBType.number(),
  /* @prop */
  allLogos: NBType.boolean(),
  /* @prop */
  companyId: NBType.number(),
  /* @prop */
  cvContentEnabled: NBType.boolean(),
  /* @prop */
  cvLogoQuota: NBType.number(),
  /* @prop */
  endDate: NBType.timestamp().nullable(),
  /* @prop */
  startDate: NBType.timestamp().nullable()
  /* END */
})
export default AccountProfileInfoSchema
export type AccountProfileInfo = InferType<typeof AccountProfileInfoSchema>
// RESERVE BELOW
